import React, { PureComponent } from 'react';
import { DragSource, DropTarget, DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { Field, FieldArray } from 'redux-form';
import { Icon } from 'react-fa';
import { Image } from '../index';

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <div className="form-group">
    <label>{label}</label>
    <div>
      <input className="form-control" {...input} type={type} placeholder={label}/>
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);
const Partner = ({ fields, member, index }) => {
  return (
    <div className="planet-partners__generic-member">
      <div>
        <button
          type="button"
          className="btn btn-primary btn-circle btn-remove"
          onClick={() => fields.remove(index)}><Icon name="remove"/></button>
        <div className="planet-partners__header">
          <h4>Partner #{index + 1}</h4>
        </div>

        <Field
          name={`${member}.name`}
          type="text"
          component={renderField}
          label="Name"/>

        <Field
          name={`${member}.webSite`}
          type="text"
          component={renderField}
          label="Web site"/>
      </div>


      <div className="planet-partners__img">
        <Field
          name={`${member}.imageUrl`}
          component={Image}
          label="Image"/>
      </div>
    </div>
  );

};
const renderPartners = ({ connectDragSource, connectDropTarget, fields, meta: { error, submitFailed } }) => (

  <div className="planet-partners__generics">
    <div className="planet-partners__header">
      <button className="btn btn-primary" type="button" onClick={() => fields.push({})}>Add new partner</button>
      {submitFailed && error && <span>{error}</span>}
    </div>
    <div className="row">
      {fields.map((member, index) => (
        <div className="col-md-4 col-xs-12" key={index}>
          {connectDragSource(connectDropTarget(<Partner fields={fields} member={member} index={index}/>))}
        </div>
      ))}
    </div>
  </div>
);


class Partners extends PureComponent {

  render() {
    const { connectDragSource, connectDropTarget } = this.props;
    return (
      <div className="planet-partners">
        <FieldArray
          name="partners"
          connectDragSource={connectDragSource}
          connectDropTarget={connectDropTarget}
          component={renderPartners}/>
      </div>
    );
  }
}

const cardSource = {
  beginDrag(props) {
    console.log("------| beginDrag |------");
    return { index: props.index };
  },
  canDrag(props) {
    const { model } = props;
    console.log("------| canDrag |------", !!model, props);
    return !!model;
  }
};

const cardTarget = {
  drop(props, monitor) {
    console.log("------| drop |------");
    const dragIndex = monitor.getItem().index;
    const dropIndex = props.index;

    if (dragIndex === dropIndex) {
      return;
    }

    props.move(dragIndex, dropIndex);
  },
  canDrop: function (props) {
    console.log("------| canDrop |------");
    const { model } = props;
    return !!model;
  }
};

const name = 'Partners';

Partners.propTypes = {};
Partners.defaultProps = {};

Partners = DragSource(name, cardSource, (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
})(Partners);


Partners = DropTarget(name, cardTarget, (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
})(Partners);

export default DragDropContext(HTML5Backend)(Partners);




// WEBPACK FOOTER //
// ./src/components/partners/Partners.js